
export const viewport = () => {
    let call = document.querySelector('.call');
    let whyUs = document.querySelector('.why-us');
    let whyUsItem = document.querySelector('.why-us-item');

    if(whyUs) addAnimationByScroll(whyUs);
    
    if(call) addAnimationByScroll(call);

    if(whyUsItem) addAnimationByScroll(whyUsItem);

    function addAnimationByScroll (el) {

        function isElementInViewport (el) {

    
            var rect = el.getBoundingClientRect();
        
            return (
                parseInt(rect.top) >= 0 &&
                parseInt(rect.left) >= 0 &&
                parseInt(rect.bottom) <= (window.innerHeight || document.documentElement.clientHeight) * (5 / 4) &&
                parseInt(rect.right) <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
    
        function onVisibilityChange(el, callback) {
            var old_visible;
            return function () {
                var visible = isElementInViewport(el);
                
                if (visible != old_visible) {
                    old_visible = visible;
                    if (typeof callback == 'function') {
                        callback(visible);
                    }
                }
            }
        }
        
        var handler = onVisibilityChange(el, function(visible) {
          
            /* Your code go here */
            let animationBLock = el.querySelectorAll('.animation-fadeUp');
            animationBLock.forEach(element => {
                if(visible){
                    element.classList.add("animated");
                }
                else{   
                    if(element.classList.contains("loop")){
                        element.classList.remove("animated");
                    }
                    
                }
                
            });
        });
        
    
        addEventListener('scroll', handler, false);

        
    }



    
}
